import axiosInstance from "../services/axiosInstance";
import * as Endpoints from "../entities/Endpoints";

// API to fetch conversation details
export const fetchConversationsApi = async (coachId) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_CONVERSION_DETAILS}?coachId=${coachId}`
  );

  return response?.data?.data || [];
};
// API to fetch conversation details
export const fetchMessengerCheckInClientsListApi = async (coachId) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_MESSENGER_CHECKIN_CLIENTS_LIST}?coachId=${coachId}`
  );

  return response?.data || [];
};

export const filterConversationsApi = async (coachId, filter) => {
  const response = await axiosInstance.get(
    `${Endpoints.GET_MESSENGER_CLIENTS_LIST_BY_FILTER}?coachId=${coachId}&filter=${filter}`
  );
  return response.data;
};

export const resetUnreadCountApi = async (conversationSid) => {
  const response = await axiosInstance.post(
    `${Endpoints.RESET_UNREAD_COUNT}?conversationSid=${conversationSid}`
  );
  return response.data;
};
